module.exports = __webpack_public_path__ + "img/glovo_rating_bad.18a8167f.svg";